import { PositionInGroup } from '../../common/ui/avatar-thread';
export var calculateNotificationPositionInGroup = function calculateNotificationPositionInGroup(notificationIndex, group) {
  // if size is 1 we should never render as a group
  if (group.size === 1) {
    return undefined;
  }

  // If we are loading and we only have 1 notification, don't show as a group
  if (group.notifications.length <= 1 && !group.isLoading) {
    return undefined;
  }
  if (notificationIndex === group.notifications.length - 1 && !group.isLoading) {
    return PositionInGroup.LAST;
  }
  switch (notificationIndex) {
    case 0:
      return PositionInGroup.FIRST;
    case group.size - 1:
      return PositionInGroup.LAST;
    default:
      return PositionInGroup.MIDDLE;
  }
};
export var getSkeletonCount = function getSkeletonCount(group) {
  // We want to try to render the expected number of notications
  // that will load when the group is expanded.
  //
  // The max that we will load is 5 at a time.
  return Math.min(5, group.size - group.notifications.length);
};